/**
 * @vuelto-surface
 * mobile: ok
 * desktop: ok
 * strategy: inherit
 */

/**
 * Moneda canónica es-AR para toda la app: `$1.500`.
 *
 * - Enteros sin decimales: `$1.500`, `$0`
 * - Con centavos: 2 decimales fijos `$1.316,70` (`toLocaleString` pelado
 *   dropea el cero final → `$1.316,7`; este helper no).
 * - Negativos con el signo adelante: `-$1.500`.
 * - Sin espacio entre `$` y el número. NO usar
 *   `Intl.NumberFormat(style: 'currency', currency: 'ARS')` en pantalla:
 *   en Hermes produce `$ 1.500` con espacio (variante inconsistente).
 *
 * Para montos editables en inputs usar `formatEditableMoneyAmount`
 * (shared/numeric) — sin símbolo.
 */
export function formatMoney(n: number): string {
  if (!Number.isFinite(n)) return '—';
  const sign = n < 0 ? '-' : '';
  const abs = Math.abs(n);
  const hasDecimals = abs % 1 !== 0;
  return `${sign}$${abs.toLocaleString('es-AR', {
    minimumFractionDigits: hasDecimals ? 2 : 0,
    maximumFractionDigits: 2,
  })}`;
}

/**
 * Formatea dinero en formato compacto para KPIs y headers.
 *
 * - ≥ 1.000.000 → `$1,2M` (abreviatura con coma decimal AR)
 * - < 1.000.000 → `$45.000` (completo, sin decimales)
 *
 * Usar SOLO en KPIs, headers y resúmenes donde la precisión exacta
 * no es crítica. Para vistas de detalle, filas, modales y CSV usar
 * `formatMoney` de este mismo módulo.
 */
export function formatMoneyCompact(n: number): string {
  const abs = Math.abs(n);
  if (abs >= 1_000_000) {
    const millions = n / 1_000_000;
    return `$${millions.toLocaleString('es-AR', { maximumFractionDigits: 1 })}M`;
  }
  return `$${n.toLocaleString('es-AR', { maximumFractionDigits: 0 })}`;
}
